export const listTableOption = {
  page:false,
  border: true,
  stripe: true,
  align:'center',
  menuAlign:'center',
  refreshBtn: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  column: [{
    label: 'ID',
    prop: 'id',
    overHidden: true,
    align: 'center',
    width: 120,
  }, {
    label: '评论内容',
    prop: 'content',
    overHidden: true,
    align: 'left',
    width: 140,
    solt: true,
  }, {
    label: '评论人Full Name',
    prop: 'commentByName',
    align: 'left',
    overHidden: true,
    width: 140,
    solt: true,
  }, {
    label: '评论人Birth Name',
    prop: 'commentByRealname',
    align: 'left',
    overHidden: true,
    width: 140,
    solt: true,
  }, {
    label: '评论时间',
    width: 160,
    prop: 'commentTime',
    overHidden: true,
    sortable: true,
    align: 'left'
  }, {
    label: '点赞数',
    width: 100,
    prop: 'likeCount',
    overHidden: true,
    sortable: true,
    hide: true,
    align: 'left'
  }, {
    label: '评论数',
    width: 100,
    prop: 'commentCount',
    overHidden: true,
    sortable: true,
    hide: true,
    align: 'left'
  }, {
    label: '回复对象的评论内容',
    width: 160,
    prop: 'commentToContent',
    overHidden: true,
    align: 'left',
    solt: true,
  }, {
    label: '回复对象Full Name',
    prop: 'commentToName',
    align: 'left',
    overHidden: true,
    width: 160,
    solt: true,
  }, {
    label: '回复对象Birth Name',
    prop: 'commentToRealname',
    align: 'left',
    overHidden: true,
    width: 160,
    solt: true,
  }, {
    label: '回复对象评论时间 ',
    prop: 'commentToTime',
    align: 'left',
    overHidden: true,
    width: 160,
  }, {
    label: '评论所在内容预览',
    width: 240,
    prop: 'postTitle',
    overHidden: true,
    solt: true,
    align: 'left'
  }, {
    label: '内容状态',
    width: 80,
    prop: 'postStatus',
    overHidden: true,
    align: 'left'
  }, {
    label: '此评论是否已下架',
    prop: 'isNotBanned',
    align: 'left',
    width: 140,
  }, {
    label: '下架原因',
    prop: 'banComment',
    overHidden: true,
    align: 'left',
    width: 160,
  }]
}
